import React from 'react';
import TopImage from '../img/bg_3.jpg';

function NominationsPage() {
  return (
    <>
                      <div className="history-image-wrapper">
        <img src={TopImage} alt="История конкурса" className="history-top-image" />
      </div>
    <div className="nominations-container">
      <h1 className="nominations-header">
        Номинации и критерии оценки Международного конкурса дизайнеров одежды «Эволюция стиля»
      </h1>
      <div className="nomination">
        <h2 className="nomination-title">Лучший дизайнер мужской одежды</h2>
        <p className="nomination-description">
          Эта номинация признает выдающегося дизайнера, чья коллекция мужской одежды отличается инновационным подходом, высоким уровнем мастерства и актуальностью для современного мужчины. Жюри оценивает способность дизайнера создавать стильные, функциональные и элегантные образы, отражающие современные тенденции и индивидуальность целевой аудитории.
        </p>
        <h3 className="criteria-title">Критерии оценки:</h3>
        <ul className="criteria-list">
          <li>Оригинальность и креативность решений</li>
          <li>Качество кроя, пошива и используемых материалов</li>
          <li>Способность коллекции соответствовать потребностям и образу жизни современного мужчины</li>
          <li>Влияние коллекции на индустрию и новые тренды</li>
        </ul>
      </div>
      <div className="nomination">
        <h2 className="nomination-title">Лучший дизайнер женской одежды</h2>
        <p className="nomination-description">
          Номинация для признания таланта дизайнера, создающего инновационные и выразительные коллекции женской одежды. Особое внимание уделяется гармоничности форм, цветовых решений и умению сочетать классику с современными веяниями, удовлетворяя потребности разнообразной женской аудитории.
        </p>
        <h3 className="criteria-title">Критерии оценки:</h3>
        <ul className="criteria-list">
          <li>Эстетическая выразительность и уникальность коллекции</li>
          <li>Техническое мастерство и качество исполнения изделий</li>
          <li>Способность адаптировать дизайн под различные типажи и стили</li>
          <li>Значимость и оригинальность предложенных модных решений</li>
        </ul>
      </div>
      {/* Аналогичный блок для остальных номинаций */}
      <div className="nomination">
        <h2 className="nomination-title">Лучший дизайнер детской одежды</h2>
        <p className="nomination-description">
          Данная категория направлена на выявление дизайнера, который умеет создавать комфортные, безопасные и стильные вещи для детей. Коллекции должны сочетать креативность с практичностью, учитывать особенности детской физиологии и потребности юных пользователей.
        </p>
        <h3 className="criteria-title">Критерии оценки:</h3>
        <ul className="criteria-list">
          <li>Удобство и безопасность изделий</li>
          <li>Яркость, игривость и оригинальность дизайна</li>
          <li>Качество материалов и технологий пошива, пригодных для детей</li>
          <li>Соответствие современным тенденциям в детской моде</li>
        </ul>
      </div>

      <div className="nomination">
        <h2 className="nomination-title">Лучший инновационный дизайнер</h2>
        <p className="nomination-description">
        Эта номинация выделяет дизайнера, который привносит в мир моды новаторские идеи и решения. Особое внимание уделяется использованию нестандартных материалов, технологий или методик, которые меняют подход к созданию одежды и открывают новые горизонты в дизайне.
        </p>
        <h3 className="criteria-title">Критерии оценки:</h3>
        <ul className="criteria-list">
        <li>Внедрение новых технологий и материалов</li>
        <li>Смелость и креативность в поиске инновационных решений</li>
        <li>Влияние инноваций на общий эстетический и функциональный уровень коллекции</li>
        <li>Потенциал предложенных решений изменить индустрию или создать новые тренды</li>
        </ul>
      </div>

      <div className="nomination">
        <h2 className="nomination-title">Выдающийся предприниматель года</h2>
        <p className="nomination-description">
        Номинация для предпринимателя или владельца модного бренда, который проявил исключительные лидерские качества, достиг значительных результатов в бизнесе и внес заметный вклад в развитие модной индустрии. Оцениваются стратегическое видение, инновации в управлении и успехи на рынке.
        </p>
        <h3 className="criteria-title">Критерии оценки:</h3>
        <ul className="criteria-list">
        <li>Достижения и рост бизнеса за отчетный период</li>
        <li>Вклад в развитие индустрии и поддержку молодых талантов</li>
        <li>Инновационные подходы к ведению бизнеса и маркетингу</li>
        <li>Социальная и экологическая ответственность бренда</li>
        </ul>
      </div>

      <div className="nomination">
        <h2 className="nomination-title">Лучшая инновация в текстиле</h2>
        <p className="nomination-description">
        Эта категория посвящена разработке и использованию уникальных текстильных материалов, которые демонстрируют технологический прорыв в области моды. Коллекции, представленные в этой номинации, должны показать, как новые ткани и методы обработки могут улучшить качество, функциональность и эстетику одежды.
        </p>
        <h3 className="criteria-title">Критерии оценки:</h3>
        <ul className="criteria-list">
        <li>Уникальность и технологичность нового текстиля</li>
        <li>Практическое применение инноваций в коллекциях</li>
        <li>Экологичность и устойчивость материалов</li>
        <li>Влияние текстильных инноваций на процессы производства и конечный продукт</li>
        </ul>
      </div>

      <div className="nomination">
        <h2 className="nomination-title">Лучшая коллекция вечерней моды</h2>
        <p className="nomination-description">
        В номинации оцениваются коллекции, предназначенные для особых случаев и торжественных мероприятий. Дизайнеры демонстрируют высокий уровень мастерства, элегантность и утонченность, создавая образы, способные подчеркнуть индивидуальность и стиль современной женщины или мужчины на вечерних мероприятиях.
        </p>
        <h3 className="criteria-title">Критерии оценки:</h3>
        <ul className="criteria-list">
        <li>Элегантность и изысканность дизайна</li>
        <li>Качество тканей, отделки и исполнения</li>
        <li>Способность коллекции подчеркнуть статус и уникальность ее владельца</li>
        <li>Соответствие актуальным модным тенденциям и инновационность решений</li>
        </ul>
      </div>

      <div className="nomination">
        <h2 className="nomination-title">Лучший дизайнер молодежной моды</h2>
        <p className="nomination-description">
        Эта номинация акцентирует внимание на талантах, создающих модные и актуальные коллекции для молодежи. Дизайнеры должны уметь сочетать современные тренды с ярким и самобытным стилем, отражающим дух нового поколения и его стремление к экспериментам.
        </p>
        <h3 className="criteria-title">Критерии оценки:</h3>
        <ul className="criteria-list">
        <li>Актуальность и модность коллекции</li>
        <li>Способность дизайнера уловить и интерпретировать запросы молодежи</li>
        <li>Креативность, энергичность и оригинальность решений</li>
        <li>Коммерческий и культурный потенциал коллекций на рынке молодежной моды</li>
        </ul>
      </div>
    </div>
    </>
  );
}

export default NominationsPage;
